import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import MainSection from "./real_estate_template_components/MainSection";
import FooterComponent from "./real_estate_template_components/FooterComponent";

const Container = styled(Box)(({ theme }) => ({
  width: "100%",
  height: "100%",
  overflow: "hidden",
  position: "relative",
}));

const RealEstateTemplate = ({
  logoURL,
  contentState,
  formState,
  primaryColor,
  bgURLs,
}) => {
  return (
    <Container>
      <MainSection
        logoURL={logoURL}
        formState={formState}
        contentState={contentState}
        primaryColor={primaryColor}
        bgURLs={bgURLs}
      />
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 20,
        }}
      >
        <FooterComponent contentState={contentState} />
      </Box>
    </Container>
  );
};

export default RealEstateTemplate;
